import { LOGIN_CONSENT_FAILURE, LOGIN_CONSENT_SUCCESS } from 'state/actions/login-consent';
import { type HandledActions, type ConsentOutcomeState } from './types';

export const defaultState: ConsentOutcomeState = {
    uri: undefined,
};

export function ConsentOutcomeReducer(
    state: ConsentOutcomeState = defaultState,
    action: HandledActions
): ConsentOutcomeState {
    switch (action.type) {
        case LOGIN_CONSENT_SUCCESS:
            return {
                ...state,
                uri: action.payload.uri,
            };

        case LOGIN_CONSENT_FAILURE:
            return {
                ...state,
                errorStatus: action.payload.error,
            };

        default:
            return state;
    }
}
